import { Box } from '@mantine/core';
import { Text as FoundationsText } from '@repo/foundations';
import { get, isNil } from 'lodash-es';
import type { ISecodaEntity } from '../../api/index.ts';

interface OptimizedNumberRenderProps<T> {
	record: T;
	field: string;
	label?: string;
}

/**
 * Lightweight read-only component to display numbers.
 * Used when user doesn't have permission to edit.
 */
export function OptimizedNumberRender<T extends ISecodaEntity>({
	record,
	field,
	label,
}: OptimizedNumberRenderProps<T>) {
	const value = get(record, field) as number;

	return (
		<>
			{!isNil(value) && (
				<FoundationsText style={{ textWrap: 'nowrap' }} size="sm">
					{value}
				</FoundationsText>
			)}
			{isNil(value) && (
				<Box aria-label="placeholder">
					<FoundationsText size="sm" color="text/secondary/default">
						Add {label ?? field}
					</FoundationsText>
				</Box>
			)}
		</>
	);
}
